import { useTitle } from "@/lib/brand";
import { PageHead } from "@/components/Kit";

/**
 * PRIVACY — rebuilt 2026-10-27. Same policy as 08-16, brought up to what is true today: training
 * is the paid purchase (not buying an Expert), the browser code that remembers what it owns, the
 * subject sent to the training service and the AI provider it uses, and no third-party fonts.
 * For Dog's review before it is relied on.
 */
const SECTIONS = [
  ["The app", "Experts runs entirely on your device. Your conversations never leave your phone. They are not sent to us, not stored on our servers and not used to train anything. We cannot read them."],
  ["What the app downloads", "The app downloads the Engine and any Experts you choose from our servers. These are one-way downloads; nothing about how you use them is sent back."],
  ["Reports", "If you report an answer, the app sends us that answer, any note you write, and which Expert produced it. Your question is not sent. This happens only when you tap Report."],
  ["Training an Expert", "When you train an Expert, the subject you name is sent to our training service and kept with the training record so the Expert can be built and delivered to you. To check facts and write training material, the service uses a third-party AI model provider, which receives the subject and the public source material — never anything from your phone."],
  ["What this website keeps", "This website stores a random code in your browser's local storage (not a cookie) so it can show you the Experts you trained and your recovery words. It is not linked to a name, an email or an account. When you download the app we record that a download happened: that code, a one-way hash of your IP address (never the address itself) and the time — only to count installs."],
  ["Payments", "Payment for training is handled by Stripe. We receive confirmation that the payment completed and an order record. We never receive or store your card details."],
  ["What we never do", "We do not sell data. We do not share data with advertisers. We do not use tracking cookies, third-party analytics or third-party fonts. We do not build profiles."],
  ["Deleting your data", "To ask us to delete anything we hold, email expertsllc@proton.me."],
  ["Children", "Experts is not directed at children under 13."],
  ["Contact", "IP Experts LLC · expertsllc@proton.me"],
];

export default function PrivacyPage() {
  useTitle("Privacy");
  return (
    <main data-testid="privacy-page" className="ex-page">
      <div className="ex-narrow pb-28">
        <PageHead eyebrow="Privacy policy" title="Private by design." lede="Experts — IP Experts LLC · Last updated October 27, 2026" />
        <div className="ex-hairline divide-y divide-[color:var(--ex-line)]">
          {SECTIONS.map(([h, b]) => (
            <section key={h} className="grid gap-2 md:grid-cols-[220px_1fr] md:gap-8 p-6 md:p-7">
              <h2 className="text-white text-[15px] font-medium">{h}</h2>
              <p className="ex-body">{b}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
